module.exports = __webpack_public_path__ + "static/img/Tevita-Penai.a3a21f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tevita-Penai.jpg
// module id = cuPQ
// module chunks = 0